import { ChangeDetectionStrategy, Component, inject, Signal } from '@angular/core';
import { ReactiveFormsModule, Validators } from '@angular/forms';

import { ButtonModule, DIALOG_DATA, DialogRef, DictionaryItem, IconModule, SelectComponent } from '@hglobal/fin-ui';
import { FormBuilder } from '@ngneat/reactive-forms';
import { TranslateModule } from '@ngx-translate/core';
import dayjs from 'dayjs';

import { SearchSelectComponent, StatusIconComponent } from '@kr/components';
import { DictionariesService } from '@kr/services';
import { DictionariesStore } from '@kr/store';

import { TransactionsStore } from '../../transactions.store';

@Component({
  imports: [ReactiveFormsModule, TranslateModule, IconModule, ButtonModule, SelectComponent, StatusIconComponent, SearchSelectComponent],
  selector: 'kr-monthly-report',
  templateUrl: './monthly-report.component.html',
  styleUrls: ['./monthly-report.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MonthlyReportComponent {
  readonly #dialogRef = inject(DialogRef);
  readonly #fb = inject(FormBuilder);
  readonly #dictionariesService = inject(DictionariesService);
  readonly #dictionariesStore = inject(DictionariesStore);
  readonly #transactionsStore = inject(TransactionsStore);

  readonly data = inject(DIALOG_DATA);

  readonly months = this.#dictionariesService.months;
  readonly years: Signal<DictionaryItem<string>[]> = this.#transactionsStore.monthlyRepYears;

  readonly providerTypes = this.#dictionariesStore.providerTypes;

  form = this.#fb.group({
    providerId: [<number>null, Validators.required],
    month: [dayjs().format('MMMM').toLowerCase(), Validators.required],
    year: [dayjs().format('YYYY'), Validators.required],
  });

  constructor() {
    this.#transactionsStore.getMonthlyRepYears();
  }

  readonly providerIdEffect = () => {
    const providerTypes = this.providerTypes();

    if (providerTypes && providerTypes.length > 0) {
      this.form.patchValue({ providerId: providerTypes[0].id });
    }
  };

  close(): void {
    this.#dialogRef.close();
  }

  save(): void {
    const { month, year, providerId } = this.form.value;
    const selectedDate = dayjs(`${year}-${month}-01`);
    const createdGte = selectedDate.startOf('month').unix();
    const createdLt = selectedDate.endOf('month').unix();

    this.#dialogRef.close({
      createdGte,
      createdLt,
      providerId,
    });
  }
}
